export const QaServiceFrag = `
fragment QaServiceFrag on QAContainerService { 
  title {
    value
  }
  description {
    value
  }
  image {
    src
    alt
    width
    height
  }
  link {
    url
    text
    target
  }
}`;
